/* eslint-disable camelcase */
import { type UseMutationResult, useMutation, useQueryClient } from 'react-query';
import { toast } from 'react-toastify';
import ToastComponent from '../../components/toast';
import {
  CommissionService,
  Wealthlane_Shared_Hosting_Dtos_GenericApiResponse,
} from '@wealthlane/api-services/wealthlane-award-service';

const usePostCommissionRateSchedule = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  closeModal: () => void,
  id?: string
): UseMutationResult<
  Wealthlane_Shared_Hosting_Dtos_GenericApiResponse | undefined,
  unknown,
  any,
  unknown
> => {
  const queryClient = useQueryClient();
  return useMutation(
    async (payload: any) => {
      if (id != null && id !== '') {
        return await handleRequest(
          CommissionService.putApiAwardApiAppCommissionCommissionRateSchedule({
            ...payload,
            id,
          })
        );
      }
      return await handleRequest(
        CommissionService.postApiAwardApiAppCommissionCommissionRateSchedule(payload)
      );
    },
    {
      onSuccess: async (
        response:
          | Wealthlane_Shared_Hosting_Dtos_GenericApiResponse
          | Wealthlane_Shared_Hosting_Dtos_GenericApiResponse
          | undefined
      ) => {
        if (response != null) {
          await queryClient.invalidateQueries('getCommissionList');
          closeModal();
          toast.success(
            <ToastComponent
              label='Success'
              message={`Commission Rate Schedule ${id != null && id != '' ? 'edited.' : 'added.'}`}
            />
          );
        }
      },
      onError: (err) => {
        console.log('error', err);
      },
    }
  );
};

export default usePostCommissionRateSchedule;
